import { render, staticRenderFns } from "./BikeMaintenancesHistory.vue?vue&type=template&id=18fd8a44&lang=pug&"
import script from "./BikeMaintenancesHistory.vue?vue&type=script&lang=js&"
export * from "./BikeMaintenancesHistory.vue?vue&type=script&lang=js&"
import style0 from "./BikeMaintenancesHistory.vue?vue&type=style&index=0&id=18fd8a44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports